import styled from 'styled-components'

const PlaceholderBox = styled.div`
  background-color: ${(props) => props.theme.palette.neutral.default.seven};
`

export default PlaceholderBox
